import React from "react"
import { graphql } from "gatsby"
import CommonTemplate from "templates/common-template"
import styled from "@emotion/styled"
import TextWithImage from "components/pages/textWithImage"
import SingleColumn from "components/pages/singleColumn"
import MultiColumn from "components/pages/multiColumn"
import { Container, Flex, Box } from "theme-ui"
import PricingList from "components/lists/pricing-list"
import ForMoreInfo from "components/for-more-information"
import GetHelp from "components/get-help"
import { useBreakpointIndex } from "@theme-ui/match-media"
import "react-tabs/style/react-tabs.css"

const FullWidthPricing = styled.div`
    margin-left: calc(50% - 50vw) !important;
    margin-right: calc(50% - 50vw) !important;
    padding: 1rem;
    padding-top: 5rem;

    & .pricing-wrapper {
        justify-content: space-between;
        flex-direction: column;
    }
    & .tab-wrapper {
        text-align: center;
    }
    & .tnc p {
        color: ${(props) => props.theme.colors.text1};
        margin-top: 2rem;
        text-align: center;
    }
    & .for-more-info {
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        margin-top: 1rem;
        & a {
            color: ${(props) => props.theme.colors.green};
        }
    }
    & h3 {
        font-family: "Playfair Display";
        text-align: center;
        font-style: italic;
        color: #510291;
    }
    & .react-tabs__tab {
        color: ${(props) => props.theme.colors.primary};
    }
    & .react-tabs__tab--selected {
        font-weight: bold;
        background: transparent;
        border: none;
        border-bottom: 4px solid ${(props) => props.theme.colors.primary};
    }
    & .react-tabs__tab-list {
        border: none;
        margin-bottom: 1rem;
    }
`

const ContentWrapper = styled.div`
    position: relative;
    text-align: center;
    margin-bottom: 3rem;
    display: flex;
    flex-direction: row;
    z-index: 10;

    & .content-wrapper {
        flex: 0 0 70%;
    }
    & .side-box-wrapper {
        flex-direction: column;
        flex: 0 0 30%;
    }

    @media (max-width: ${(props) => props.theme.breakpoints[4]}) {
        flex-direction: column;
    }
`

const IconText = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: ${(props) => props.theme.colors.light_blue_1};
    color: ${(props) => props.theme.colors.primary};
    border-radius: 1.5rem;
    font-weight: bold;
    margin-bottom: 1rem;
    margin-right: 1rem;
    & img {
        margin-right: 0.5rem;
    }
    & span {
        text-decoration: underline;
    }
`

const OurProcessWrapper = styled.div`
    & .banner-wrapper {
        flex-direction: row-reverse;
        @media (max-width: ${(props) => props.theme.breakpoints[4]}) {
            flex-direction: column;
        }
    }
`

const SingleColumnWrapper = styled.div`
    & .content-margin {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        & > div {
            flex: 0 0 70%;
        }
        @media (max-width: ${(props) => props.theme.breakpoints[4]}) {
            & > div {
                margin-top: 1rem;
                flex: 0 0 100%;
            }
        }
    }
`
const SingleColumnSplit = styled.div`
    & .content-margin > div > ul {
        column-count: 2;
        @media (max-width: ${(props) => props.theme.breakpoints[4]}) {
            column-count: 1;
        }
    }
`

// markup
const IndexPage = ({ location, data, pageContext }) => {
    const { pageData } = data
    const contents = pageData.content
    const prefix = process.env.PREFIX_SLUG
    const breakpoint = useBreakpointIndex()

    let pageContent = null
    let priceList = []
    let priceInfo = []
    let textWithImage = []
    let singleColumn = []
    let iconText = []
    let isFirstColumn = true
    if (contents !== undefined && contents) {
        pageContent = contents.map((content, index) => {
            let html = null
            if (
                content.Single_Column !== undefined &&
                content.Single_Column !== null
            ) {
                if (isFirstColumn) {
                    html = (
                        <SingleColumnSplit>
                            <SingleColumn
                                data={content.Single_Column}
                                key={index}
                            />
                        </SingleColumnSplit>
                    )
                } else {
                    singleColumn.push(
                        <SingleColumnWrapper>
                            <SingleColumn
                                data={content.Single_Column}
                                key={index}
                            />
                        </SingleColumnWrapper>
                    )
                }
                isFirstColumn = false
            } else if (
                content.Text_With_Image !== undefined &&
                content.Text_With_Image !== null
            ) {
                textWithImage.push(
                    <TextWithImage key={index} data={content.Text_With_Image} />
                )
            } else if (
                content.Multi_Columns !== undefined &&
                content.Multi_Columns !== null
            ) {
                html = <MultiColumn data={content.Multi_Columns} key={index} />
            } else if (
                content.Pricing_Details !== undefined &&
                content.Pricing_Details !== null
            ) {
                priceList.push(content.Pricing_Details)
                priceInfo.push(content.Pricing_Info)
            } else if (
                content.icon_text_layout !== undefined &&
                content.icon_text_layout !== null
            ) {
                const icon_text_layout = {
                    ...content.icon_text_layout,
                    text_alignment: "left",
                }
                const icons =
                    content.icon_and_text.length &&
                    content.icon_and_text.map((el, idx) => (
                        <Box sx={{ flex: "0 0 30%", padding: "0.5rem 1rem" }}>
                            <IconText key={idx}>
                                <img
                                    height="48"
                                    width="48"
                                    src={el.icon && el.icon.publicURL}
                                    alt=""
                                />
                                <span>{el.title}</span>
                            </IconText>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: el.content,
                                }}
                            />
                        </Box>
                    ))
                iconText.push(
                    <>
                        <SingleColumn data={icon_text_layout} key={index} />
                        <Flex
                            sx={{
                                flexWrap: "wrap",
                                justifyContent: "flex-start",
                                flexDirection:
                                    breakpoint > 4 ? "row" : "column",
                            }}
                        >
                            {icons}
                        </Flex>
                    </>
                )
            }
            return html
        })
    }

    let content = (
        <>
            <ContentWrapper>
                <div className="content-wrapper">{pageContent}</div>
            </ContentWrapper>
        </>
    )
    let pricing = (
        <FullWidthPricing>
            <Container>
                <h3>Counselling & Psychotherapy Fees</h3>
                <Box>
                    {priceList.map((price, idx) => (
                        <Box key={idx}>
                            <Flex className="pricing-wrapper">
                                <PricingList data={price} />
                            </Flex>
                            {priceInfo[idx] && (
                                <div
                                    className="tnc"
                                    dangerouslySetInnerHTML={{
                                        __html: priceInfo[idx]
                                            .terms_and_conditions,
                                    }}
                                />
                            )}
                        </Box>
                    ))}
                </Box>
                <div className="for-more-info">
                    <ForMoreInfo />
                </div>
            </Container>
        </FullWidthPricing>
    )

    let customJsx = (
        <>
            {content}
            {singleColumn}
            {textWithImage}
            {iconText}
            {pricing}
            <GetHelp />
        </>
    )

    let arrData = {
        location,
        data,
        customElement: customJsx,
        onlyCustom: "partial",
    }
    if (pageContext.slug === `${prefix}-faqs`) {
        arrData = {
            location,
            data,
        }
    } else if (pageContext.slug === `${prefix}-our-process`) {
        customJsx = (
            <>
                {pageContent}
                {singleColumn}
                {textWithImage}
                {iconText}
                <GetHelp />
            </>
        )
        arrData = {
            location,
            data,
            customElement: customJsx,
            onlyCustom: "partial",
        }
        return (
            <OurProcessWrapper>
                <CommonTemplate {...arrData} />
            </OurProcessWrapper>
        )
    }

    return <CommonTemplate {...arrData} />
}

export default IndexPage

export const query = graphql`
    query GetStartedQuery($slug: String!) {
        pageData: strapiPage(
            slug: { eq: $slug }
            company: { shortname: { eq: "WNS" } }
        ) {
            title
            menu_title
            description
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
            image {
                childImageSharp {
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                    gatsbyImageData(placeholder: BLURRED)
                }
            }
            banner: image {
                childImageSharp {
                    gatsbyImageData(placeholder: BLURRED)
                }
            }
            imageDesc: image {
                childImageSharp {
                    gatsbyImageData(placeholder: BLURRED)
                }
            }
            category {
                name
                subtitle
                category_img {
                    childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                    }
                }
            }
            content {
                Single_Column {
                    Text_Alignment
                    content
                    id
                    title
                }
                Multi_Columns {
                    Text_Alignment
                    content
                    id
                    title
                }
                Text_With_Image {
                    Image_Size
                    Layout_Type
                    content
                    title
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                backgroundColor: "#f2f2f2"
                            )
                            original {
                                width
                            }
                        }
                    }
                }
                Gallery_Image {
                    title
                    media {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                backgroundColor: "#f2f2f2"
                            )
                        }
                        publicURL
                    }
                }
                Accordion {
                    content
                    title
                }
                external_script {
                    name
                    script
                }
                Pricing_Details {
                    label
                    price
                    unit
                }
                Pricing_Info {
                    title
                    additional_text
                    terms_and_conditions
                }
                icon_and_text {
                    title
                    content
                    icon {
                        publicURL
                    }
                }
                icon_text_layout {
                    content
                }
            }
        }
        posts: allStrapiPage(
            filter: {
                category: { slug: { eq: "get-started" } }
                company: { shortname: { eq: "WNS" } }
                slug: { ne: $slug }
            }
        ) {
            edges {
                node {
                    strapiId
                    slug
                    title
                }
            }
        }
    }
`
